import {
  Modal,
  ModalContent,
  ModalHeader,
} from '@stereograph/teia-system-design/components/Modal';
import { usePluginTranslation } from '@translation';
import { AnomalyDocumentVisualizer } from './AnomalyDocumentVisualizer';

interface AnomalyDocumentVisualizationModalProps {
  isModalOpen: boolean;
  onClose: () => void;
}

export const AnomalyDocumentVisualizationModal = (props: AnomalyDocumentVisualizationModalProps) => {
  const { isModalOpen, onClose } = props;
  const { t } = usePluginTranslation();

  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      closeOnBackdropClick
      fullWidth
      maxWidth="lg"
      sx={{
        '& .MuiDialog-paperScrollPaper': {
          maxHeight: '100%',
        },
      }}
    >
      <ModalHeader>{t('anomaly_plugin.widget.visualize.title')}</ModalHeader>
      <ModalContent sx={{
        display: 'flex',
        overflowY: 'hidden',
      }}
      >
        <AnomalyDocumentVisualizer />
      </ModalContent>
    </Modal>
  );
};
